<template>
  <div class="wrapper">
    <div class="popupContent">
      <AppEditableTextarea
        ref="nameEditor"
        :value="point.name"
        :editing="isEditNameMode"
        @edit="toEditNameMode"
        @apply="updatePointName"
        class="name"
      />
      <div v-if="canEdit" class="popupContentToolbar">
        <AppEditButton
          :disabled="!canEdit"
          :editing="isEditNameMode"
          @onEditClick="toEditNameMode()"
          @onSaveClick="exitEditNameMode()"
        />
        <AppUndoButton
          ref="nameUndo"
          :name="point.name"
          @pop="popNameHandler"
        />
      </div>
    </div>
    <div v-if="canEdit" class="popupFooter">
      <AppInactiveSwitch
        v-if="isShowSwitch"
        :disabled="isSwitchDisabled"
        :status="isSwitchActive"
        @change="onChange($event)"
        with-label
      />
      <DeleteButton :point="point" with-label />
    </div>
  </div>
</template>

<script>
import DeleteButton from '@/components/Advertiser/Operation/PointGroup/PointGroupOperation/Point/DeleteButton'
import AppUndoButton from '@/components/App/AppUndoButton'

import { actions } from '@/vuex/modules/pointGroupOperation/constants'
import RouteHelper from '@/mixins/RouteHelper'
import cloneDeep from 'lodash/cloneDeep'
import AppEditableTextarea from '@/components/App/AppEditableTextarea'
import AppEditButton from '@/components/App/AppEditButton'
import AppInactiveSwitch from '@/components/App/AppInactiveSwitch'
import immer from 'immer'

export default {
  name: 'PointGroupPopupContent',
  components: {
    AppInactiveSwitch,
    DeleteButton,
    AppEditButton,
    AppUndoButton,
    AppEditableTextarea,
  },
  mixins: [RouteHelper],
  props: { point: Object, hasEditPermission: Boolean },
  data() {
    return {
      isEditNameMode: false,
    }
  },
  computed: {
    canEdit() {
      return !this.underSystemOwnerPage && this.hasEditPermission
    },
    isSwitchActive() {
      return this.point.status === 'active'
    },
    isSwitchDisabled() {
      return !(this.point.toDelete !== true && this.point)
    },
    isShowSwitch() {
      return !this.point.newItem.new
    },
  },
  methods: {
    toEditNameMode() {
      this.isEditNameMode = true
      this.$nextTick(() => {
        const targetTextarea = document.getElementById('editName')
        targetTextarea.focus()
      })
    },
    exitEditNameMode() {
      this.$refs.nameEditor.applyName()
    },
    updatePointName({ value }) {
      this.isEditNameMode = false
      if (value !== this.point.name) {
        this.$refs.nameUndo.push(value)

        const point = cloneDeep(this.point)
        point.name = value
        this.$store.dispatch(actions.EDIT_GROUP_POINT, { data: point })
      }
    },
    popNameHandler(name) {
      const point = { ...this.point, name }
      this.$store.dispatch(actions.EDIT_GROUP_POINT, { data: point })
    },
    onChange(isActive) {
      const point = cloneDeep(this.point)
      const data = immer(point, draft => {
        draft.status = isActive ? 'active' : 'inactive'
      })
      this.$store.dispatch(actions.EDIT_GROUP_POINT, {
        data,
      })
    },
  },
}
</script>

<style scoped lang="scss">
.wrapper {
  position: relative;
  height: 100%;
  display: flex;
  flex-flow: column;
  justify-content: space-between;
  align-items: center;
  padding: 10px 10px 0;
}
.popupContent {
  display: flex;
  flex-direction: row;
  width: 100%;
}

.popupContentToolbar {
  width: 40px;
}

.popupFooter {
  position: absolute;
  bottom: 0;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;
  width: 100%;
  padding: 0 10px;
}
.name {
  flex: 1;
  padding: 10px;
}
</style>
